export default {
    START_LOADING: 'START_LOADING',
    END_LOADING: 'END_LOADING',
};



// WEBPACK FOOTER //
// ./src/components/Loader/LoaderConstants.js